module.exports = __webpack_public_path__ + "static/media/DSC09613.4a84d6d6.jpg";